import { useState } from 'react'
import { useCompanion } from '@/hooks/useCompanion'
import { setCompanionEnabled } from '@/lib/companion'
import { useToasts } from '@/lib/toast'

export function CompanionSettings() {
  const { userId, familyId, preference } = useCompanion()
  const [error, setError] = useState('')
  const pushToast = useToasts((s) => s.push)
  return (
    <section className="rounded-r-sm bg-bg-elevated border border-divider-subtle p-4">
      <label className="flex items-center justify-between gap-3 min-h-11 text-body text-text-primary">
        Companion mode (experimental)
        <input type="checkbox" role="switch" checked={preference} disabled={!userId || !familyId}
          aria-describedby="companion-description" className="h-5 w-5"
          onChange={(event) => {
            if (!userId || !familyId) return
            const ok = setCompanionEnabled(userId, familyId, event.target.checked)
            if (ok) {
              setError('')
              pushToast({
                title: 'Saved',
                body: `Companion mode ${event.target.checked ? 'on' : 'off'}`,
                tone: 'mint',
                ttl: 2500,
              })
            } else {
              setError('This browser could not save the preference; companion remains off.')
            }
          }} />
      </label>
      <p id="companion-description" className="text-caption text-text-secondary mt-2">
        Off by default. A quiet Today greeting and tap-to-explain rhythm meters, using your records through Wren AI.
        Text only: no voice output, push or proactive notifications. Only for your account and family on this browser; turn off anytime.
      </p>
      {error && <p role="alert" className="text-caption mt-2">{error}</p>}
    </section>
  )
}
